import { useState } from "react";

interface Props {
  onClose: () => void;
}

type Step = 1 | 2 | 3;

export default function YeniKayitModal({ onClose }: Props) {
  const [step, setStep] = useState<Step>(1);
  const [form, setForm] = useState({
    veliAdi: "",
    ogrenciAdi: "",
    telefon: "",
    seviye: "",
    odemeGunu: "",
    taahhutBitis: "",
    referansDurumu: "Vermedi",
    ogrenciDurumu: "Aktif",
    notlar: "",
  });

  const handleChange = (field: string, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const steps = [
    { num: 1, label: "Temel Bilgiler" },
    { num: 2, label: "Ödeme & Taahhüt" },
    { num: 3, label: "Onay" },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose}></div>
      <div className="relative bg-white rounded-2xl w-full max-w-lg shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
          <div>
            <h2 className="font-bold text-gray-900 text-base">Yeni Veli / Öğrenci Kaydı</h2>
            <p className="text-xs text-gray-400 mt-0.5">Adım {step} / 3</p>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-400 cursor-pointer">
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        {/* Step indicator */}
        <div className="flex px-6 py-4 gap-2">
          {steps.map((s) => (
            <div key={s.num} className="flex-1 flex flex-col items-center gap-1">
              <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-all
                ${step > s.num ? "bg-[#25D366] text-white" : step === s.num ? "bg-[#0B1120] text-white" : "bg-gray-100 text-gray-400"}
              `}>
                {step > s.num ? <i className="ri-check-line text-sm"></i> : s.num}
              </div>
              <span className={`text-[10px] ${step === s.num ? "text-gray-800 font-semibold" : "text-gray-400"}`}>{s.label}</span>
            </div>
          ))}
        </div>

        {/* Form content */}
        <div className="px-6 pb-6 space-y-4">
          {step === 1 && (
            <>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1.5">Veli Adı Soyadı *</label>
                  <input
                    type="text"
                    value={form.veliAdi}
                    onChange={(e) => handleChange("veliAdi", e.target.value)}
                    placeholder="Örn: Ayşe Yılmaz"
                    className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1.5">Öğrenci Adı Soyadı *</label>
                  <input
                    type="text"
                    value={form.ogrenciAdi}
                    onChange={(e) => handleChange("ogrenciAdi", e.target.value)}
                    placeholder="Örn: Kerem Yılmaz"
                    className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
                  />
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">WhatsApp Telefon *</label>
                <input
                  type="text"
                  value={form.telefon}
                  onChange={(e) => handleChange("telefon", e.target.value)}
                  placeholder="0532 111 2233"
                  className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1.5">Öğrenci Seviyesi</label>
                  <select
                    value={form.seviye}
                    onChange={(e) => handleChange("seviye", e.target.value)}
                    className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-white"
                  >
                    <option value="">Seçin</option>
                    {["1. Sınıf","2. Sınıf","3. Sınıf","4. Sınıf","5. Sınıf","6. Sınıf","7. Sınıf","8. Sınıf","9. Sınıf","10. Sınıf","11. Sınıf","12. Sınıf"].map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1.5">Öğrenci Durumu</label>
                  <select
                    value={form.ogrenciDurumu}
                    onChange={(e) => handleChange("ogrenciDurumu", e.target.value)}
                    className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-white"
                  >
                    <option>Aktif</option>
                    <option>Yeni</option>
                    <option>Pasif</option>
                  </select>
                </div>
              </div>
            </>
          )}

          {step === 2 && (
            <>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1.5">Ödeme Günü (1-31)</label>
                  <input
                    type="number"
                    min={1}
                    max={31}
                    value={form.odemeGunu}
                    onChange={(e) => handleChange("odemeGunu", e.target.value)}
                    placeholder="Örn: 15"
                    className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1.5">Taahhüt Bitiş Tarihi</label>
                  <input
                    type="date"
                    value={form.taahhutBitis}
                    onChange={(e) => handleChange("taahhutBitis", e.target.value)}
                    className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
                  />
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Referans Durumu</label>
                <div className="flex gap-2">
                  {["Verdi", "Vermedi", "Bekleniyor"].map((r) => (
                    <button
                      key={r}
                      type="button"
                      onClick={() => handleChange("referansDurumu", r)}
                      className={`flex-1 py-2 rounded-xl text-xs font-medium cursor-pointer transition-all whitespace-nowrap
                        ${form.referansDurumu === r
                          ? "bg-[#0B1120] text-white"
                          : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                        }
                      `}
                    >
                      {r}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Notlar (İsteğe bağlı)</label>
                <textarea
                  value={form.notlar}
                  onChange={(e) => handleChange("notlar", e.target.value)}
                  placeholder="Veli veya öğrenci hakkında notlar..."
                  rows={3}
                  maxLength={500}
                  className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] resize-none"
                />
                <p className="text-[10px] text-gray-400 text-right mt-1">{form.notlar.length}/500</p>
              </div>
            </>
          )}

          {step === 3 && (
            <div className="space-y-3">
              <div className="bg-gray-50 rounded-xl p-4 space-y-2">
                {[
                  { label: "Veli Adı", value: form.veliAdi || "-" },
                  { label: "Öğrenci Adı", value: form.ogrenciAdi || "-" },
                  { label: "Telefon", value: form.telefon || "-" },
                  { label: "Seviye", value: form.seviye || "-" },
                  { label: "Ödeme Günü", value: form.odemeGunu ? `${form.odemeGunu}. gün` : "-" },
                  { label: "Taahhüt Bitiş", value: form.taahhutBitis || "-" },
                  { label: "Referans", value: form.referansDurumu },
                  { label: "Durum", value: form.ogrenciDurumu },
                ].map((row, i) => (
                  <div key={i} className="flex items-center justify-between text-sm">
                    <span className="text-gray-500">{row.label}</span>
                    <span className="font-medium text-gray-800">{row.value}</span>
                  </div>
                ))}
              </div>
              <div className="flex items-start gap-2 p-3 bg-emerald-50 rounded-xl border border-emerald-100">
                <div className="w-4 h-4 flex items-center justify-center text-emerald-500 flex-shrink-0 mt-0.5">
                  <i className="ri-information-line text-sm"></i>
                </div>
                <p className="text-xs text-emerald-700">
                  Kayıt oluşturulduktan sonra otomatik hatırlatma sistemi bu veli için aktive edilecektir.
                </p>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between px-6 py-4 border-t border-gray-100">
          <button
            onClick={() => step > 1 ? setStep((s) => (s - 1) as Step) : onClose()}
            className="px-4 py-2 text-sm text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-50 cursor-pointer whitespace-nowrap transition-colors"
          >
            {step === 1 ? "İptal" : "Geri"}
          </button>
          {step < 3 ? (
            <button
              onClick={() => setStep((s) => (s + 1) as Step)}
              className="px-6 py-2 text-sm bg-[#0B1120] text-white rounded-xl hover:bg-[#1a2a4a] cursor-pointer whitespace-nowrap transition-colors flex items-center gap-2"
            >
              Sonraki Adım
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </button>
          ) : (
            <button
              onClick={onClose}
              className="px-6 py-2 text-sm bg-[#25D366] text-white rounded-xl hover:bg-[#1da851] cursor-pointer whitespace-nowrap transition-colors flex items-center gap-2"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-checkbox-circle-line text-sm"></i>
              </div>
              Kaydı Oluştur
            </button>
          )}
        </div>
      </div>
    </div>
  );
}